import { RelationshipKind } from '@metaos/mfs-client';
/** The contains relationship used on the graph portion of Folder to identify whenever a card is contained within another card*/
export const containsRelationship = {
    type: 'contains',
    direction: 'out',
    kind: RelationshipKind.TwoWay,
};
export const containsRelationshipIn = {
    ...containsRelationship,
    direction: 'in',
};
export const taggedRelationship = {
    type: 'tagged',
    direction: 'out',
    kind: RelationshipKind.TwoWay,
};
export const taggedRelationshipIn = {
    ...taggedRelationship,
    direction: 'in',
};
export const tagContainerRelationship = {
    type: 'tag contained',
    direction: 'out',
    kind: RelationshipKind.TwoWay,
};
export const tagContainerRelationshipIn = {
    ...tagContainerRelationship,
    direction: 'in',
};
//# sourceMappingURL=internalRelationships.js.map